import React, { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Clock, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function SopralluogoAttesaButton({ cid, flusso, sopraDone, onSaved }) {
  const [saving, setSaving] = useState(false);
  const active = flusso === "attesa_conferma";

  const toggle = async () => {
    setSaving(true);
    try {
      await api.post(`/clienti/${cid}/sopralluogo/attesa-conferma`);
      toast.success(active ? "Stato rimosso" : "Segnato: in attesa conferma installazione da fornitore");
      onSaved?.();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <div className="card-shell p-4 flex flex-wrap items-center gap-3" data-testid="sopralluogo-attesa-block">
      <button onClick={toggle} disabled={saving || !sopraDone}
        className={`text-sm ${active ? "btn-primary" : "btn-secondary"} disabled:opacity-50`}
        title={!sopraDone ? "Completa prima tutte le sezioni del sopralluogo" : ""}
        data-testid="sopralluogo-attesa-btn">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : active ? <CheckCircle2 className="w-4 h-4" /> : <Clock className="w-4 h-4" />}
        {active ? "In attesa conferma installazione da fornitore ✓" : "In attesa conferma installazione da fornitore"}
      </button>
      <span className="text-xs flex-1 min-w-[200px]" style={{ color: "var(--text-muted)" }}>
        {sopraDone ? "Segna che stai attendendo la conferma dell'installazione dal fornitore." : "Disponibile a sopralluogo completato."}
      </span>
    </div>
  );
}
